export const SET_TYPE_PLAYER_LOCK = 'SET_TYPE_PLAYER_LOCK';
export const RESET_TYPE_PLAYER_LOCK = 'RESET_TYPE_PLAYER_LOCK';
